import React from "react";
import { SectionHeader } from "@/shell/components/SectionHeader";
import { CustomerLifecycleMonth } from "@/features/orders-analytics/types/orders-analytics.types";
import { formatters } from "@/features/orders-analytics/utils/formatters";

type Props = {
    months: CustomerLifecycleMonth[];
};

const activeTotal = (month: CustomerLifecycleMonth): number =>
    month.newAccounts + month.returningAccounts + month.reactivatedAccounts;

// Most recent month first — the backend returns months ascending.
const toDescending = (months: CustomerLifecycleMonth[]): CustomerLifecycleMonth[] =>
    [...months].reverse();

export const LifecycleSection: React.FC<Props> = ({ months }) => (
    <section className="section">
        <SectionHeader
            title="Lifecycle composition"
            count={months.length}
            meta="active accounts per month, split by lifecycle stage"
        />
        <div className="card ci-table-card">
            <div className="ci-scroll">
                <table className="ci-tbl">
                    <thead>
                        <tr>
                            <th scope="col">Month</th>
                            <th scope="col" className="num">Active</th>
                            <th scope="col" className="num">New</th>
                            <th scope="col" className="num">Returning</th>
                            <th scope="col" className="num">Reactivated</th>
                        </tr>
                    </thead>
                    <tbody>
                        {toDescending(months).map((month) => (
                            <tr key={month.month}>
                                <td style={{ fontWeight: 600 }}>{month.label}</td>
                                <td className="num">{formatters.formatNumber(activeTotal(month))}</td>
                                <td className="num">{formatters.formatNumber(month.newAccounts)}</td>
                                <td className="num">{formatters.formatNumber(month.returningAccounts)}</td>
                                <td className="num">{formatters.formatNumber(month.reactivatedAccounts)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </section>
);
